import { connect } from 'react-redux'

// Material-UI
import { makeStyles } from 'tss-react/mui';

// React-Bootstrap
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'

// React Router
import {
  BrowserRouter as Router,
  Link as LinkRouter
} from 'react-router-dom';

// App
import { classificationStyles } from "../styles/common";
import CuiBanner from "../components/CuiBanner";
import backgroundImage from '../assets/images/background-footer.png';

// App logo
import appLogo from '../assets/images/app_logo_wide_dark.svg'; // RAPIDS
import agentLogo from '../assets/images/app_logo_agent.svg';   // AGENT
import llLogo from '../assets/images/orgs/logo-LincolnLaboratory.png';

// Icon imports
import { IconContext } from 'react-icons';

const useStyles = makeStyles()({
  pageFooter: {
    backgroundColor: '#003E65',
    background: `url(${backgroundImage})`,
    margin: '0 0px',
    padding: 'calc(28px + 2%) 6% 20px 8%',
    border: '0px',
    maxWidth: '100%',
    minHeight: '150px',
    color: 'white',
    fontSize: '14px',
  },
  footerInfo: {
    margin: '0 40px 60px 0',
  },
  appLogo: {
    marginBottom: '12px',
    '& a': {
      paddingLeft: 0,
      width: '100%',
    },
    '& img': {
      width: '45%',
      height: 'auto',
      maxWidth: '300px',
      minWidth: '200px',
      maxHeight: '100px', 
      marginBottom: '15px'
    },
  },
  tagLine: {
    fontSize: 'calc(15px + 0.5vmin)',
    paddingLeft: 0,
  },
  appDescription: {
    fontSize: 'calc(11px + 0.5vmin)',
    paddingTop: '12px',
    maxWidth: '860px'
  },
  lincolnLabLogo: {
    margin: '55px 0 55px -15px',
    '& a': {
      paddingLeft: 0,
      width: '100%',
    },
    '& img': {
      width: '90%',
      height: 'auto',
      maxWidth: '385px',
      maxHeight: '40px', 
    },
  },
  buildInfo: {
    display: 'flex',
    color: 'lightGrey', 
    padding: '10px 0', 
    fontSize: 'calc(11px + 0.5vmin)',
    '& *': {
      paddingLeft: 0,
    },
  },
  footerLinks: {
    maxWidth: '400px',
    marginBottom: '20px',
    '& > h4': {
      fontSize: 'calc(14px + 0.5vmin)',
    },
    '& div': {
      margin: '0 0 12px 0',
      minWidth: '110px',
    },
    '& a': {
      color: '#FFAF13',
      fontSize: 'calc(11px + 0.5vmin)',
      fontWeight: 'normal',
    },
    '& a:hover': {
      color: '#ffca61',
    },
  },
  pageLinks: {
    maxWidth: '220px',
    minWidth: '170px',
  },
  lastLinks: {
    '& div': {
      minWidth: '224px',
    }
  },
  centerStatement: {
    display: 'flex',
    justifyContent: 'center',
    padding: 5
  },
  ...classificationStyles()
});

function ChallengeFooter({ logged_in, APIBuildInfo, pageInfo, can_create_study, can_create_model, ...props }) {
  const { classes } = useStyles();
  
  let branch = window._env_.APP_BRANCH || '';
  let build = window._env_.APP_BUILD || '';
  let build_date = window._env_.APP_BUILD_TIMESTAMP || '';
  let UIBuildInfo = branch ? (branch + ' #' + build + ' (' + build_date + ')') : 'Local build';

  return (
    <IconContext.Provider value={{ size: '1.4em', style: {marginTop: '-1px', marginRight: '8px'} }}>
      <Container className={classes.pageFooter + ' page-footer'}>
        <Row>
          <Col xs={12} lg={6} className={classes.footerInfo}>
            {/*<Row className={classes.appLogo}>*/}
            {/*  <LinkRouter to='/'>*/}
            {/*    {(window._env_?.CUI_APP) &&*/}
            {/*        <img src={agentLogo} alt='app-footer' className='d-inline-block align-top'/>*/}
            {/*    }*/}
            {/*    {(!window._env_?.CUI_APP) &&*/}
            {/*        <img src={appLogo} alt='app-footer' className='d-inline-block align-top'/>*/}
            {/*    }*/}
            {/*  </LinkRouter>*/}
            {/*</Row>*/}
            <Row>
              <h4 className={classes.tagLine}><b>{window._env_.APP_TAG_LINE}</b></h4>
            </Row>
            <Row className={classes.appDescription}>
              {window._env_.APP_NAME} is a platform that enables researchers to store and share 
              curated, de-identified data, and is working towards storing and sharing models, results, 
              and analyses. {window._env_.APP_NAME} is being developed by MIT Lincoln Laboratory as a 
              research effort with funding from the National Institutes of Health (NIH), the Defense 
              Threat Reduction Agency (DTRA), and the Biomedical Advanced Research and Development 
              Authority (BARDA).
            </Row>
          </Col>
          
          <Col xs={12} xl={1} className={classes.footerLinks + ' ' + classes.pageLinks}>
            <h4><b>Challenge Site</b></h4>
            <div>
              <LinkRouter to='/guide' style={{color: '#DEC1FF'}}>About</LinkRouter>
            </div>
            {(logged_in && true) &&
                <div>
                  <LinkRouter to='/my_team' style={{color: '#DEC1FF'}}>My Team</LinkRouter>
                </div>
            }
            {(logged_in) &&
              <div>
                <LinkRouter to='/userprofile' style={{color: '#25bcd4'}}>User Profile</LinkRouter>
              </div>
            }
            {(logged_in) &&
              <div>
                <LinkRouter to='/ethicspledge' style={{color: '#DEC1FF'}}>Ethics Pledge</LinkRouter>
              </div>
            }
          </Col>

          <Col xs={12} xl={2} className={classes.footerLinks}>
            {/*<h4><b>Industry Partners</b></h4>*/}
            {/*<div>*/}
            {/*  <a href='https://www.nih.gov/' target='_blank' rel='noreferrer' style={{color: '#DEC1FF'}}>*/}
            {/*    Partner 1*/}
            {/*  </a>*/}
            {/*</div>*/}
          </Col>

          <Col xs={12} xl={2} className={classes.footerLinks + ' ' + classes.lastLinks}>
            <h4><b>Developer</b></h4>
            <div style={{ marginBottom: '30px'}}>
              <a href='https://www.ll.mit.edu/' target='_blank' rel='noreferrer' style={{color: '#DEC1FF'}}>
                MIT Lincoln Laboratory</a>
            </div>
            <h4><b>Support</b></h4>
            <div>
              <a href={'mailto:' + window._env_.APP_SUPPORT_EMAIL + '?subject=Support Request'} style={{color: '#DEC1FF'}}>
                {window._env_.APP_SUPPORT_EMAIL}</a>
            </div>
          </Col>
        </Row>

        <Row className={classes.lincolnLabLogo}>
          <a href='https://www.ll.mit.edu/' target='_blank' rel='noreferrer'>
            <img src={llLogo} alt='lincoln-laboratory' className='d-inline-block align-top' />
          </a>
        </Row>
        { (window._env_.APP_PRODUCTION !== 'true') &&
          <Row className={classes.buildInfo}>
            <span>UI: {UIBuildInfo}</span>
            <br />
            <br />
            <span>API: {APIBuildInfo}</span>
          </Row>
        }
      </Container>
      <CuiBanner />
      <CuiBanner stickyBottom={true} />
    </IconContext.Provider>
  );
}

const mapStateToProps = (state) => {
  return {
    APIBuildInfo: state.buildInfo,
    pageInfo: state.pageInfo,
    logged_in: state.userInfo?.logged_in,
    email_verified: state.userInfo?.email_verified,
    can_create_study: state.userInfo.can_create_study,
    can_create_model: state.userInfo.can_create_model,
    resources: state.userInfo.available_resources
  }
}

export default connect(mapStateToProps)(ChallengeFooter);
